import netlifyIdentity from 'netlify-identity-widget'

export const isLoggedIn = () => {
  if (netlifyIdentity.currentUser()) {
    return true
  } else {
    return false
  }
}



// WEBPACK FOOTER //
// ./src/helpers/auth.js